<template>
    <div>
        <div class="flash-message">
            <FlashMessage :position="'top'"></FlashMessage>
        </div>
        <div class="h4 mb-3">
            <div class="d-flex align-items-center justify-content-between">
                <strong class="white-space-nowrap">Add-ons</strong>
                <span class="add-ons"></span>
                <div v-if="removeInterval===false" class="d-flex">
                    <div>
                        <button class="btn btn-success" @click="save">Save</button>
                    </div>
                </div>
            </div>
        </div>
        <table class="table border">
            <thead class="table-bordered">
            <tr>
                <th>Add-on</th>
                <th style="width: 84px;">Type</th>
                <th>Configurations</th>
                <th v-if="userType === userTypeClient" style="width: 116px;" class="text-center">Pre-selected</th>
                <th v-if="userType === userTypeClient" style="width: 182px;">Pre-selected options</th>
            </tr>
            </thead>
            <tbody class="table-bordered">
            <tr v-if="agreementAddOn.active===1 && userType == agreementAddOn.user_type"
                v-for="(agreementAddOn, index) in agreementAddOns"
            >
                <td style="width: 40%">
                    <div>{{ agreementAddOn.add_on.name }}</div>
                    <div v-if="agreementAddOn.add_on.description">{{ agreementAddOn.add_on.description }}</div>
                </td>
                <td><strong>{{ tripTypes[agreementAddOn.add_on.type] }}</strong></td>
                <td v-if="agreementAddOn.add_on.key === addOnCallFromDriver">
                    <div class="d-flex align-items-center">
                        <div>
                            <div class="d-flex align-items-center">
                                <input
                                    class="form-control small-input"
                                    type="number"
                                    step="0.01"
                                    v-model="agreementAddOn.configurations['price']"
                                >
                                <span class="ml-2">kr.</span>
                            </div>
                            <div class="text-danger mb-1"
                                 v-if="errors[`agreementAddOns.${index}.configurations.price`]">
                                {{ errors[`agreementAddOns.${index}.configurations.price`] }}
                            </div>
                        </div>
                    </div>
                </td>
                <td v-else-if="agreementAddOn.add_on.key === addOnFutureDays">
                    <div class="d-flex justify-content-between">
                        <div class="">
                            <div class="d-flex align-items-center justify-content-center mb-1">
                                <span class="mr-3 pl-3">Default</span>
                                <input
                                    class="form-control small-input mr-3"
                                    type="number"
                                    step="1"
                                    v-model="agreementAddOn.configurations['future_days']"
                                >
                                <span>Days</span>
                            </div>
                            <div class="text-danger mb-1" v-if="errors[`agreementAddOns.${index}.configurations.future_days`]">
                                {{ errors[`agreementAddOns.${index}.configurations.future_days`] }}
                            </div>
                            <div class="d-flex align-items-center justify-content-center mb-2">
                                <span class="mr-3">Want more?</span>
                                <input
                                    class="form-control small-input mr-3"
                                    type="number"
                                    step="1"
                                    v-model="agreementAddOn.configurations['want_more']"
                                >
                                <span>Weeks</span>
                            </div>
                            <div class="text-danger mb-1" v-if="errors[`agreementAddOns.${index}.configurations.want_more`]">
                                {{ errors[`agreementAddOns.${index}.configurations.want_more`] }}
                            </div>
                        </div>
                    </div>
                </td>
                <td v-else-if="agreementAddOn.add_on.key === addOnShorterTimeInterval">
                    <div class="d-flex flex-wrap">
                        <div v-for="(val, i) in agreementAddOn.configurations">
                            <div class="d-flex align-items-center mb-1 mr-4">
                                <div v-if="agreementAddOn.configurations[i]['option']" class="mr-3">
                                    <div>
                                        {{ agreementAddOn.configurations[i]['option'] }}
                                    </div>
                                </div>
                                <div class="d-flex align-items-center mr-3" v-else>
                                    <div class="mr-1">
                                        {{ agreementAddOn.configurations[i]['from'] }}
                                    </div>
                                    <div class="mr-1">-</div>
                                    <div class="mr-1">
                                        {{ agreementAddOn.configurations[i]['to'] }}
                                    </div>
                                </div>
                                <div>
                                    <div class="d-flex align-items-center justify-content-center">
                                        <input
                                            class="form-control small-input"
                                            type="text"
                                            id="shorter-time-interval-before-12"
                                            placeholder="Price"
                                            v-model="agreementAddOn.configurations[i]['price']"
                                            @change="onChangeAddOnPrice(index, i)"
                                        >
                                        <span class="ml-2">kr.</span>
                                    </div>
                                </div>
                            </div>
                            <div class="text-danger mb-1" v-if="errors[`agreementAddOns.${index}.configurations.${i}.price`]">
                                {{ errors[`agreementAddOns.${index}.configurations.${i}.price`] }}
                            </div>
                        </div>
                    </div>
                </td>
                <td v-else>
                    <div class="d-flex align-items-center">
                        <div class="address-type-label bold-font mr-5" style="min-width: 50px;">
                            <strong>Price</strong>
                        </div>
                        <div>
                            <div class="d-flex align-items-center">
                                <input
                                    class="form-control small-input"
                                    type="number"
                                    step="0.01"
                                    v-model="agreementAddOn.configurations['price']"
                                >
                                <span class="ml-2">kr.</span>
                            </div>
                            <div class="text-danger mb-1"
                                 v-if="errors[`agreementAddOns.${index}.configurations.price`]">
                                {{ errors[`agreementAddOns.${index}.configurations.price`] }}
                            </div>
                        </div>
                    </div>
                </td>
                <td v-if="userType === userTypeClient">
                    <label class="newInput">
                        <input type="checkbox"
                               v-model="agreementAddOn.pre_selected"
                               @change="onPreSelectChanged(index)"
                        >
                        <span class="checkmark" style="top: -6px; left: 35px;"></span>
                    </label>
                </td>
                <td v-if="userType === userTypeClient">
                    <div v-if="agreementAddOn.add_on.key === addOnShorterTimeInterval">
                        <div class="d-flex align-items-center" v-if="agreementAddOn.pre_selected">
                            <v-select
                                class="w-100"
                                :options="agreementAddOn.configurations"
                                label="from"
                                v-model="preSelectedOptions[agreementAddOn.add_on.key]"
                            >
                                <template #option="{ from, to, option }">
                                    <div v-if="option">
                                        <span>{{ option }}</span>
                                    </div>
                                    <div v-else>
                                        <span>{{ from }}</span>-<span>{{ to }}</span>
                                    </div>
                                </template>
                                <template #selected-option="{ from, to, option }">
                                    <div v-if="option">
                                        <span>{{ option }}</span>
                                    </div>
                                    <div v-else>
                                        <span>{{ from }}</span>-<span>{{ to }}</span>
                                    </div>
                                </template>
                            </v-select>
                        </div>
                    </div>
                </td>
            </tr>
            </tbody>
        </table>
    </div>

</template>

<script type="text/ecmascript-6">
export default {
    name: "AgreementAddOnEdit",
    props: {
        agreement: {type: Object, required: true},
        removeInterval: {type: Boolean, required: true},
        agreementAddOnsProp: {type: Array, required: true},
        userType: {type: Number|String, required: true},
        userTypeClient: {type: String, required: true},
        addOnCallFromDriver: {type: Number, required: true},
        addOnFutureDays: {type: Number, required: true},
        addOnShorterTimeInterval: {type: Number, required: true},
        typePickup: {type: Number, required: true},
        typeDropoff: {type: Number, required: true},
        tripTypes: {type: Object, required: true},
    },
    data() {
        return {
            agreementAddOns: JSON.parse(JSON.stringify(this.agreementAddOnsProp)),
            errors: {},
            preSelectedOptions: {}
        }
    },
    methods: {
        save() {
            this.errors = {};
            axios.patch(`/save-agreement-add-ons/${this.agreement.id}`, {
                userType: this.userType,
                preSelectedOptions: this.preSelectedOptions,
                agreementAddOns: this.agreementAddOns
            }).then((response) => {
                this.flashMessage.success({
                    title: '',
                    message: "Add-ons have been updated successfully",
                    time: 2000,
                    blockClass: 'flash-message'
                });

            }).catch(err => {
                this.flashMessage.error({
                    title: '',
                    message: err.response.data.message,
                    time: 2000,
                    blockClass: 'flash-message error'
                });
                console.log(err.response.data);

                if (err.response.data.errors) {
                    for(let i in err.response.data.errors) {
                        this.$set(this.errors, i, err.response.data.errors[i][0])
                    }
                }
            });
        },
        onPreSelectChanged(index) {
            this.agreementAddOns[index].pre_selected = this.agreementAddOns[index].pre_selected ? 1 : 0;
        },
        onChangeAddOnPrice(addOnIndex, configIndex) {
            if (configIndex &&
                this.agreementAddOns[addOnIndex].pre_selected_options
            ) {
                if (
                    (
                        this.agreementAddOns[addOnIndex].configurations[configIndex].option &&
                        this.agreementAddOns[addOnIndex].configurations[configIndex].option === this.agreementAddOns[addOnIndex].pre_selected_options.option
                    ) ||
                    (
                        this.agreementAddOns[addOnIndex].configurations[configIndex].option &&
                        this.agreementAddOns[addOnIndex].pre_selected_options.option === `${this.agreementAddOns[addOnIndex].configurations[configIndex].from} - ${this.agreementAddOns[addOnIndex].configurations[configIndex].to}`
                    )
                ) {
                    this.$set(this.agreementAddOns[addOnIndex].pre_selected_options, 'price', this.agreementAddOns[addOnIndex].configurations[configIndex]['price'])
                }
            }
        }

    },
    created() {
        this.agreementAddOns.forEach((agreementAddOn) => {
            if (agreementAddOn.pre_selected_options) {
                this.$set(this.preSelectedOptions, agreementAddOn.add_on.key, agreementAddOn.pre_selected_options);
            }
        })
    }
}
</script>

<style scoped>
.small-input {
    max-width: 140px;
}
.form-control[type="checkbox"]:focus {
    box-shadow: none;
}

</style>
